import { AppState } from '../root-reducer';
import { SearchItem, SearchState } from './definitions';

export const selectSearch = (state: AppState): SearchState => state.searchReducer;

export const selectIsLoading = (state: AppState): boolean => selectSearch(state).loading;
export const selectSearchResponse = (state: AppState): SearchItem[] => selectSearch(state).searchResponse;
export const selectRelationalData = (state: AppState): SearchItem[] => selectSearch(state).searchRelationalData;
